import React from "react";

const SvgRub = (props) => (
  <svg
    width="29"
    height="42"
    viewBox="0 0 29 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.40003 23.52V28.74H20.62V31.98H9.40003V42H5.14003V31.98H0.280029V28.74H5.14003V23.52H0.280029V19.74H5.14003V0H15.76C19.6 0 22.64 1.02 24.88 3.06C27.12 5.06 28.24 7.98 28.24 11.82C28.24 15.78 27.14 18.72 24.94 20.64C22.74 22.56 19.68 23.52 15.76 23.52H9.40003ZM9.40003 19.74H15.22C18.14 19.74 20.32 19.14 21.76 17.94C23.24 16.74 23.98 14.7 23.98 11.82C23.98 6.46 21.06 3.78 15.22 3.78H9.40003V19.74Z" />
  </svg>
);

export default SvgRub;
